export const HTTP_ACTION_DOING = 'HTTP_ACTION_DOING';
export const HTTP_ACTION_DONE = 'HTTP_ACTION_DONE';
export const HTTP_ACTION_ERROR = 'HTTP_ACTION_ERROR';



// WEBPACK FOOTER //
// ./src/store/http/constants.js